<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thông tin thể loại bài viết</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên thể loại bài viết:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              :label-class="editing ? 'required':''">
                                    <b-form-input type="text" id="name" v-if="editing"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blogCategory.name.$model"
                                                  :state="$v.blogCategory.name.$dirty? !$v.blogCategory.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tên thể loại bài viết
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6" v-if="!editing">{{ blogCategory.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="SeoTitle:"
                                              label-for="name"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.seoTitle.$model"
                                                     :state=" $v.blogCategory.seoTitle.$model && $v.blogCategory.seoTitle.$dirty ? !$v.blogCategory.seoTitle.$error : null"
                                                     v-if="editing"
                                                     class="col-6" id="MetaTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.seoTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6" v-if="!editing">{{ blogCategory.seoTitle }}</label>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaTitle:"
                                              label-for="name"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.metaTitle.$model"
                                                     :state=" $v.blogCategory.metaTitle.$model && $v.blogCategory.metaTitle.$dirty ? !$v.blogCategory.metaTitle.$error : null"
                                                     v-if="editing"
                                                     class="col-6" id="MetaTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.metaTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6" v-if="!editing">{{ blogCategory.metaTitle }}</label>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaKeywords:"
                                              label-for="MetaKeywords"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.metaKeywords.$model"
                                                     :state="$v.blogCategory.metaKeywords.$model && $v.blogCategory.metaKeywords.$dirty ? !$v.blogCategory.metaKeywords.$error : null"
                                                     v-if="editing" class="col-6" id="MetaKeywords" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.metaKeywords.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6" v-if="!editing">{{ blogCategory.metaKeywords }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaDescriptions:"
                                              label-for="MetaDescriptions"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blogCategory.metaDescriptions.$model"
                                                     :state=" $v.blogCategory.metaDescriptions.$model && $v.blogCategory.metaDescriptions.$dirty ? !$v.blogCategory.metaDescriptions.$error : null"
                                                     v-if="editing" class="col-6" id="MetaDescriptions" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blogCategory.metaDescriptions.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6" v-if="!editing">{{ blogCategory.metaDescriptions }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Số thứ tự hiển thị:"
                                              label-align="right"
                                              label-for="description"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-input type="number"
                                                  class="col-6"
                                                  v-if="editing"
                                                  v-model="blogCategory.displayOrder">
                                    </b-form-input>
                                    <label class="col-form-label col-6 " v-if="!editing">{{ blogCategory.displayOrder }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Trạng thái:"
                                              label-align="right"
                                              label-for="status"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-checkbox id="status" v-if="editing" v-model="blogCategory.status" class="col-6 col-form-label"></b-form-checkbox>
                                    <label class="col-form-label col-6 " v-if="!editing">{{ $store.getters.getStatusName(blogCategory.status ? 1 : 0) }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                                    <b-button type="button" variant="secondary" @click="back" v-if="!editing">Quay lại</b-button>
                                    <b-button type="submit" variant="primary" v-if="editing && authorize(['ManageBlogCategory'])">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel" v-if="editing">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, minLength, maxLength, } from 'vuelidate/lib/validators'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'blogCategoryDetail',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                blogCategory: {},
                editing: this.$route.meta.editing,
            }
        },
        computed: {
            blogCategoryId() {
                return this.$route.params.blogCategoryId;
            },
        },
        validations: {
            blogCategory: {
                name: {
                    required,
                    maxLength: maxLength(128)
                },
                metaTitle: {
                    maxLength: maxLength(256)
                },
                metaKeywords: {
                    maxLength: maxLength(256)
                },
                metaDescriptions: {
                    maxLength: maxLength(256)
                },
                seoTitle: {
                    maxLength: maxLength(256)
                },
            },
        },
        watch: {
            //'unitType.code'(newVal) {
            //    this.checkExistCode(newVal);
            //}
        },
        created() {
            this.loadBlogCategoryDetail();
        },
        methods: {
            loadBlogCategoryDetail() {
                var vm = this;
                return this.$services.get(`master-data/blog-categories/${this.blogCategoryId}`).done(blogCategory => {
                    vm.blogCategory = blogCategory;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '/master-data/blog-categories' });
            },
            cancel() {
                var vm = this;
                this.loadBlogCategoryDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.put(`master-data/blog-categories/${this.blogCategoryId}`, this.blogCategory).done(() => {
                        vm.$toastr.s('Cập nhật thể loại bài viết thành công');
                        vm.cancel();
                    });
                }
            },
            checkExistCode(newVal) {
                if (newVal) {
                    //var vm = this;
                    //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.unitType.id || null}`).done(returnData => {
                    //    if (!returnData) {
                    //        this.codeUnique = "required";
                    //    }
                    //    else {
                    //        this.codeUnique = "";
                    //    }
                    //});
                }
                else {
                    this.codeUnique = "required";
                }
            }
        }
    }
</script>
<style scoped>
</style>
